module.exports = __webpack_public_path__ + "1f4be3ce9042328a181848fc2edb6a2a.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/demo-ui/asset/icon-font/fontello.ttf
// module id = 699
// module chunks = 0